import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";

export default {
  name: "Schedule",
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ["dataObj"],
  data: function () {
    return {
      isEdit: false,
      perEnd: "",
      perBegin: "",
      schedule: {
        activityId: 0,
        applicationId: 0,
        comment: "",
        employee: "",
        employeeId: 0,
        id: 0,
        isMultiple: false,
        periodBegin: moment(new Date()).format(),
        periodDate: moment(new Date()).format(),
        periodDuration: "0",
        periodEnd: moment(new Date()).format(),
        periodType: "",
        periodTypeId: 0,
        rateType: "",
        rateTypeId: 0,
        readOnly: false,
        selection: [],
        usageType: "",
        usageTypeId: 0,
        uuid: "",
      },
      employee: {
        displayString: "",
        employeeId: 0,
        employeeName: "",
        orgPost: 0,
        orgPostName: "",
        rateHours: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        station: 0,
        stationName: "",
        teamId: -1,
      },
      employees: [],
      employeesAll: [],
      rateTypes: [],
      usageTypes: [],
      periodTypes: [],
      orgPosts: [],
      orgPost: { text: "", value: "" },
      orgPostId: -1,
      stations: [],
      station: { text: "", value: "" },
      stationId: -1,
      bWholeDay: false,
      selection: [],
    };
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
  },
  validations: {
    employee: {
      required,
    },
    rateType: {
      required,
    },
    usageType: {
      required,
    },
  },
  watch: {
    bWholeDay: function (value) {
      this.dataObj.periodTypeId = value === true ? 2 : 1;
      this.wholeDay = value;
      this.schedule.periodBegin = new Date().setHours(0, 0, 0);
      this.schedule.periodEnd = new Date().setHours(0, 0, 0);
      this.calculateDuration();
    },
    station: function (value) {
      if (!value) return;
      this.dataObj.stationId = value.value;
      this.stationId = parseInt(value.value);

      this.filterEmployees();
    },
    orgPost: function (value) {
      if (!value) return;
      this.dataObj.orgPostId = value.value;
      this.orgPostId = parseInt(value.value);

      this.filterEmployees();
    },
    "schedule.rateTypeId": function (value) {
      if (!value) return;

      if (value < 1) this.schedule.rateTypeId = 1;

      this.calculateCost();
    },
    selectionCount: function (value) {
      //console.log("sel", this.selection, "empl", this.employee,"val", value);
      this.dataObj.selection = [];
      if (value === 0) return;
      this.calculateCost();
    },
    employee: function (value) {
      //console.log("employee watch", this.employee);
      if (!value) return;

      this.selection = [];
      this.selection.push(value);
      this.calculateCost();
    },
    perBegin: function (val) {
      this.schedule.periodBegin = val;
      this.calculateDuration();
    },
    perEnd: function (val) {
      this.schedule.periodEnd = val;
      this.calculateDuration();
    },
  },
  created() {
    this.init();
  },
  methods: {
    calculateDuration() {
      //find difference and convert it to mins
      //create new dates with hours/mins on current date to avoid any mistakes in calulation by user inputing time in different days
      let start = new Date(this.schedule.periodBegin);
      let end = new Date(this.schedule.periodEnd);
      let now = new Date();

      let startNow = now.setHours(start.getHours(), start.getMinutes());
      let endNow = now.setHours(end.getHours(), end.getMinutes());

      let t = (endNow - startNow) / 1000 / 60;
      this.schedule.periodDuration = t.toString();
      //console.log("start",this.schedule.periodBegin , "end",this.schedule.periodEnd , "duration",this.schedule.periodDuration);
    },
    init() {
      Vue.nextTick(() => {
        this.isEdit = this.dataObj.isEdit;

        this.schedule = this.dataObj;
        this.stationId = this.dataObj.stationId;

        this.usageTypes = this.dataObj.usageTypes;
        if (this.schedule.isMultiple === true) {
          this.schedule.usageTypeId = this.usageTypes.filter(
            (p) => p.selected === true
          )[0].value;
          this.schedule.usageType = this.usageTypes.filter(
            (p) => p.value === this.schedule.usageTypeId
          )[0].text;
        }

        this.periodTypes = this.dataObj.periodTypes;
        if (this.schedule.isMultiple === true) {
          this.schedule.periodTypeId = this.periodTypes.filter(
            (p) => p.selected === true
          )[0].value;
          this.schedule.periodType = this.periodTypes.filter(
            (p) => p.value === this.schedule.periodTypeId
          )[0].text;
        }

        this.orgPosts = this.dataObj.orgPosts;
        this.stations = this.dataObj.stations;

        this.employees = this.dataObj.employees;
        this.employeesAll = this.dataObj.employees;

        let emp = this.employees.filter(
          (p) => p.employeeId === this.dataObj.employeeId
        );
        if (emp != null && emp.length > 0) this.employee = emp[0];

        this.rateTypes = this.dataObj.rateTypes;
        if (this.schedule.isMultiple === true) {
          this.schedule.rateTypeId =
            this.rateTypes != null
              ? this.rateTypes.filter((p) => p.selected === true)[0].value
              : "";
          this.schedule.rateType =
            this.rateTypes != null
              ? this.rateTypes.filter(
                  (p) => p.value === this.schedule.rateTypeId
                )[0].text
              : "";
        }

        this.schedule.rateTypeId =
          !this.dataObj.rateTypeId || this.dataObj.rateTypeId < 1
            ? this.dataObj.rateTypes != null
              ? this.dataObj.rateTypes[0].value
              : ""
            : this.dataObj.rateTypeId;
        this.schedule.rateType = !this.dataObj.rateType
          ? this.dataObj.rateTypes != null
            ? this.dataObj.rateTypes[0].text
            : ""
          : this.dataObj.rateType;

        this.station = this.stations.filter(
          (p) => parseInt(p.value) == this.stationId
        )[0];
        this.bWholeDay = this.dataObj.periodTypeId === 2;
        this.perEnd = this.schedule.periodEnd;
        this.perBegin = this.schedule.periodBegin;
        this.calculateDuration();
        //console.log("schedule data", this.dataObj, this.isEdit);
      });
    },
    setSelectedRateType() {
      this.schedule.rateType = this.rateTypes.filter(
        (p) => p.value === this.schedule.rateTypeId
      )[0].text;
    },
    setSelectedUsageType() {
      this.schedule.usageType = this.usageTypes.filter(
        (p) => p.value === this.schedule.usageTypeId
      )[0].text;
    },
    setSelectedPeriodType() {
      this.schedule.periodType = this.periodTypes.filter(
        (p) => p.value === this.schedule.periodTypeId
      )[0].text;
    },
    filterEmployees() {
      this.employees = this.employeesAll;
      if (this.orgPostId > -1)
        this.employees = this.employees.filter(
          (p) => p.orgPost === this.orgPostId
        );
      if (this.stationId > -1)
        this.employees = this.employees.filter(
          (p) => p.station === this.stationId
        );
    },
    calculateCost(multiple) {
      let total = 0;

      //error traps
      if (
        parseInt(this.schedule.periodDuration) < 0 ||
        isNaN(parseInt(this.schedule.periodDuration))
      ) {
        return;
      }

      if (this.selection == null || this.selection.length < 1) return;

      //add rates
      this.dataObj.selection = [];
      this.selection.forEach((p) => {
        this.dataObj.selection.push({
          id: p.employeeId,
          rate:
            p.rateHours != null ? p.rateHours[this.schedule.rateTypeId] : "",
          name: p.displayString,
        });
      });
    },
  },
};
